import AnalyticalMethod from "../../AnalyticalMethod.js";

export default class IntegrationScope {
    constructor(name) {
        this._name = name;
    }

    getName(){
        return this._name
    }

    getAnalyticalMethod(){
        return AnalyticalMethod.fromString(this.#getAnalyticalMethodName());
    }

    getDisplayName(){
        return this._name;
    }

    isDefault() {
        return this.#getAnalyticalMethodName() === this._name;
    }

    equals(that) {
        if(that === this)
            return true;
        if(!that)
            return false;
        if(that.constructor.name !== this.constructor.name)
            return false;
        return this._name === that._name;
    }

    #getAnalyticalMethodName() {
        const pos = this._name.indexOf(' ');
        if (pos !== -1)
            return this._name.substring(0, pos);
        else
            return this._name;
    }
}
